import { combineReducers } from 'redux';
import shops from './shops';
import activeToken from './activeToken';
import barcodes from './barcodes';
import barcodeTemplates from './barcodeTemplates';
import products from './products';
import locations from './locations';
import inventorySessions from './inventorySessions';
import bulkInventorySessions from './bulkInventorySessions';
import orderSessions from './orderSessions';
import pickOrder from './pickOrder';
import prints from './prints';
import settings from './settings';
import batchInventoryResults from './batchInventoryResults';
import incompleteOrders from './incompleteOrders';

export default combineReducers({
  shops,
  activeToken,
  barcodeTemplates,
  batchInventoryResults,
  products,
  barcodes,
  locations,
  inventorySessions,
  bulkInventorySessions,
  orderSessions,
  pickOrder,
  prints,
  settings,
  incompleteOrders,
});
